export enum ContentSectionId {
  TableGrid = 'content-table-grid',
  Bullets = 'bullet',
  Descriptions = 'descriptions',
  Description = 'description',
  Images = 'images',
  Videos = 'videos',
  Enhanced = 'enhanced',
  Title = 'title',
}

export const titleToId = (title: string) => {
  if (title.includes('Bullet')) {
    return ContentSectionId.Bullets;
  }
  if (title.includes('Description')) {
    return ContentSectionId.Description;
  }
  if (title.includes('Image')) {
    return ContentSectionId.Images;
  }
  if (title.includes('Video')) {
    return ContentSectionId.Videos;
  }
  if (title.includes('Enhanced')) {
    return ContentSectionId.Enhanced;
  }
  return ContentSectionId.Title;
}
